import { conversionLogsList, conversionLogRetry, conversionLogRetryAll } from '@/services/conversionLogs.service'

export default {
	namespaced: true,
	state: {
		logList: {
			data: [],
			meta: { pagination: { total: 0 } },
		},
		logStatus: 'init',
	},
	getters: {
		getLogList(state) {
			return state.logList
		},
		getLogStatus(state) {
			return state.logStatus
		},
	},
	mutations: {
		SET_LOG_LIST(state, value) {
			state.logList = value
		},
		SET_LOG_STATUS(state, value) {
			state.logStatus = value
		},
	},
	actions: {
		async fetchLogList({ commit }, params) {
			commit('SET_LOG_STATUS', 'pending')
			try {
				const { data } = await conversionLogsList(params)
				commit('SET_LOG_LIST', data)
				commit('SET_LOG_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_LOG_STATUS', 'init')
				throw error
			}
		},
		async retryLog(_, id) {
			return conversionLogRetry(id)
		},
		async retryAllFailed() {
			return conversionLogRetryAll()
		},
	},
}
